import React from 'react'
import {useKeycloak} from "@nic-react/auth";
import {RegistryRequestsController} from "./registry/RegistryRequestsController";
import RegistrarRequestsController from "./registrar/RegistrarRequestsController";


const NewRequestsController = () => {
    const {keycloak} = useKeycloak()

    if (keycloak.realm === 'registry') {
        return <RegistryRequestsController/>
    } else {
        return (<RegistrarRequestsController/>)
    }

}
export default NewRequestsController